/*=========================================================================================
  File Name: moduleEcommerceMutations.js
  Description: Ecommerce Module Mutations
==========================================================================================*/

export default {
    Recuperer(state, payload) {
        state.cartItems = payload
    }
}
